import React, { useContext, useState, useCallback } from "react";
import styled, { css } from "styled-components";
import MessageFavoriteFieldsContext from "views/components/contexts/MessageFavoriteFieldsContext";
import { Icon } from "components/common";
import Store from "logic/local-storage/Store";
import StringUtils from "util/StringUtils";
import useFormattedFields from "./hooks/useFormattedFields";
import MessageFieldsViewModeList from "./MessageFieldsViewModeList";
import useSendFavoriteFieldTelemetry from "./hooks/useSendFavoriteFieldTelemetry";
const Line = styled.div(
  ({ theme }) => css`
    border-top: 1px ${theme.colors.table.row.divider} solid;
    flex-grow: 1;
    height: 1px;
  `
);
const SeparatorContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    color: ${theme.colors.text.secondary};
    cursor: pointer;
    padding: ${theme.spacings.xxs} 0;
    font-size: ${theme.fonts.size.small};
    gap: ${theme.spacings.xs};
  `
);
const IconSeparator = ({ expanded }) => /* @__PURE__ */ React.createElement(Icon, { size: "xs", name: expanded ? "collapse_all" : "expand_all", type: "regular" });
const Separator = ({ onClick, expanded, restLength }) => {
  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick();
      }
    },
    [onClick]
  );
  return /* @__PURE__ */ React.createElement(SeparatorContainer, { onClick, role: "button", tabIndex: 0, onKeyDown }, /* @__PURE__ */ React.createElement(Line, null), /* @__PURE__ */ React.createElement(IconSeparator, { expanded }), /* @__PURE__ */ React.createElement("span", null, `${expanded ? "Hide" : "Show"} ${restLength || ""} remaining ${StringUtils.pluralize(restLength, "field", "fields")}`), /* @__PURE__ */ React.createElement(IconSeparator, { expanded }), /* @__PURE__ */ React.createElement(Line, null));
};
const SESSION_STORAGE_KEY = "message_table_show_rest-fields";
const MessageFields = () => {
  const sendFavoriteFieldTelemetry = useSendFavoriteFieldTelemetry();
  const [expanded, setExpanded] = useState(Store.sessionGet(SESSION_STORAGE_KEY) !== "false");
  const { favoriteFields } = useContext(MessageFavoriteFieldsContext);
  const { formattedFavorites, formattedRest } = useFormattedFields(favoriteFields);
  const toggleExpand = useCallback(() => {
    const isNowExpanded = !expanded;
    if (isNowExpanded) {
      Store.sessionDelete(SESSION_STORAGE_KEY);
      setExpanded(true);
    } else {
      Store.sessionSet(SESSION_STORAGE_KEY, "false");
      setExpanded(false);
    }
    sendFavoriteFieldTelemetry("NON_FAVORITE_SHOW_TOGGLED", {
      is_expanded: isNowExpanded
    });
  }, [expanded, sendFavoriteFieldTelemetry]);
  const hasFavorites = !!(formattedFavorites == null ? void 0 : formattedFavorites.length);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MessageFieldsViewModeList, { fields: formattedFavorites, isFavorite: true }), hasFavorites && /* @__PURE__ */ React.createElement(Separator, { onClick: toggleExpand, expanded, restLength: formattedRest == null ? void 0 : formattedRest.length }), (expanded || !hasFavorites) && /* @__PURE__ */ React.createElement(MessageFieldsViewModeList, { fields: formattedRest }));
};
export default MessageFields;
